import { createAction, props } from '@ngrx/store';

import { CalendarActions } from './calendar.const';
import { Event, NewEvent, NewEventOrgan, Organ, UnscheduledEvents } from './calendar.models';
import { fetchEventsProps } from './calendar.types';

export const fetchEvents = createAction(CalendarActions.fetchEvents, props<{ data: fetchEventsProps }>());
export const fetchEventsSuccess = createAction(CalendarActions.fetchEventsSuccess, props<{ data: Event[] }>());
export const fetchEventsFailure = createAction(CalendarActions.fetchEventsFailure, props<{ error: any }>());

export const fetchUnscheduledEvents = createAction(CalendarActions.fetchUnscheduledEvents);
export const fetchUnscheduledEventsSuccess = createAction(
  CalendarActions.fetchUnscheduledEventsSuccess,
  props<{ data: UnscheduledEvents }>()
);
export const fetchUnscheduledEventsFailure = createAction(
  CalendarActions.fetchUnscheduledEventsFailure,
  props<{ error: any }>()
);

export const fetchOrgans = createAction(CalendarActions.fetchOrgans);
export const fetchOrgansSuccess = createAction(CalendarActions.fetchOrgansSuccess, props<{ data: Organ[] }>());
export const fetchOrgansFailure = createAction(CalendarActions.fetchOrgansFailure, props<{ error: any }>());

export const fetchNewEventOrgans = createAction(CalendarActions.fetchNewEventOrgans);
export const fetchNewEventOrgansSuccess = createAction(
  CalendarActions.fetchNewEventOrgansSuccess,
  props<{ data: NewEventOrgan[] }>()
);
export const fetchNewEventOrgansFailure = createAction(
  CalendarActions.fetchNewEventOrgansFailure,
  props<{ error: any }>()
);

export const updateSelectedOrgans = createAction(CalendarActions.updateSelectedOrgans, props<{ data: number[] }>());
export const updateSelectedOrgansSuccess = createAction(
  CalendarActions.updateSelectedOrgansSuccess,
  props<{ data: Organ[] }>()
);
export const updateSelectedOrgansFailure = createAction(
  CalendarActions.updateSelectedOrgansFailure,
  props<{ error: any }>()
);

export const addEvent = createAction(CalendarActions.addEvent, props<{ data: NewEvent }>());
export const addEventSuccess = createAction(CalendarActions.addEventSuccess, props<{ data: Event[] }>());
export const addEventFailure = createAction(CalendarActions.addEventFailure, props<{ error: any }>());

export const removeEvents = createAction(CalendarActions.removeEvents, props<{ data: string[] }>());
export const removeEventsSuccess = createAction(CalendarActions.removeEventsSuccess, props<{ data: string[] }>());
export const removeEventsFailure = createAction(CalendarActions.removeEventsFailure, props<{ error: any }>());

export const fetchUserCanCreateEvent = createAction(CalendarActions.fetchUserCanCreateEventMeeting);
export const fetchUserCanCreateEventSuccess = createAction(
  CalendarActions.fetchUserCanCreateEventSuccess,
  props<{
    data: boolean;
  }>()
);
export const fetchUserCanCreateEventFailure = createAction(
  CalendarActions.fetchUserCanCreateEventFailure,
  props<{
    error: any;
  }>()
);

export const fetchUserCanSeeUnscheduledEvents = createAction(CalendarActions.fetchUserCanSeeUnscheduledEvents);
export const fetchUserCanSeeUnscheduledEventsSuccess = createAction(
  CalendarActions.fetchUserCanSeeUnscheduledEventsSuccess,
  props<{
    data: boolean;
  }>()
);
export const fetchUserCanSeeUnscheduledEventsFailure = createAction(
  CalendarActions.fetchUserCanSeeUnscheduledEventsFailure,
  props<{
    error: any;
  }>()
);

export const fetchNewEventCanHaveASecondMeetingDate = createAction(
  CalendarActions.fetchNewEventCanHaveASecondMeetingDate
);
export const fetchNewEventCanHaveASecondMeetingDateSuccess = createAction(
  CalendarActions.fetchNewEventCanHaveASecondMeetingDateSuccess,
  props<{
    data: boolean;
  }>()
);
export const fetchNewEventCanHaveASecondMeetingDateFailure = createAction(
  CalendarActions.fetchNewEventCanHaveASecondMeetingDateFailure,
  props<{
    error: any;
  }>()
);
